module.exports = __webpack_public_path__ + "img/bulletlist_item.555bca52.svg";